import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import { carouselData } from "@/components/Onboarding/configuration";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper";
import "swiper/less";
import { getStorage, loginStore, setStorage } from "@/modules/login/store";
import { wenxinStore } from "@/thirdParty/wenxin/store";
import classNames from "classnames";
import { Modal, ModalBody, ModalContent, useBoolean } from "@chakra-ui/react";
const Onboarding: FC<any> = (props) => {
  const lang = langStore.tgt;
  const boardingWrapperRef = useRef(null);
  const [swiper, setSwiper] = useState<any>();
  const [scatteringFlowersVisible, setScatteringFlowersVisible] = useState(true);
  const [boardingMainVisible, setBoardingMainVisible] = useState(false);
  const [promptActive, setPromptActive] = useState(1);
  useEffect(() => {
    setTimeout(() => {
      setScatteringFlowersVisible(false);
    }, 2000);
  }, []);

  const closeOnboarding = () => {
    setStorage("onboarding", "1");
    setBoardingMainVisible(false);
    wenxinStore.openHighlight();
  };
  const promptNode = useMemo(() => {
    return carouselData.map((item, index) => {
      if (index === promptActive) {
        return (
          <div className={styles.promptWrapper} key={`promptNode${index}`}>
            <span className={styles.prompt}>{item.prompt}</span>
            {item.style && <span className={styles.focusBox}>{item.style}</span>}
            {item.artist && <span className={styles.focusBox}>{item.artist}</span>}
            {item.comic && <span className={styles.focusBox}>{item.comic}</span>}
          </div>
        );
      }
    });
  }, [promptActive]);
  const carouselNode = useMemo(() => {
    return carouselData.map((item, index) => {
      return (
        <SwiperSlide
          key={`carouselNode${index}`}
          className={`${styles.swiperItem} ${index === promptActive ? styles.swipeActive : ""}`}
        >
          <li className={`${promptActive === index ? styles.active : ""}`}>
            <img src={`${item.image}?x-oss-process=image/resize,w_200`} alt="" />
          </li>
        </SwiperSlide>
      );
    });
  }, [promptActive]);

  useEffect(() => {
    if (getStorage("onboarding")) {
      return;
    } else if (localStorage.getItem("onboarding") === "1") {
      // 兼容以前直接存的情况
      setStorage("onboarding", "1");
      localStorage.removeItem("onboarding");
      return;
    }
    if (loginStore.isGuest) {
      return;
    }
    setBoardingMainVisible(true);
  }, []);

  return (
    <Modal isOpen={boardingMainVisible} onClose={closeOnboarding}>
      <ModalBody>
        <ModalContent>
          <div className={styles.boardingMain}>
            <div className={styles.boardingWrapper} ref={boardingWrapperRef}>
              <img
                src="https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/close.png"
                alt=""
                className={styles.close}
                onClick={closeOnboarding}
              />
              <p className={styles.title}>欢迎来到「画宇宙」</p>
              <p className={styles.subtitle}>新用户首次登时，会为您赠送100免费画力星</p>
              <p className={styles.subInfo}>之后每天登录时都可以获赠 30 免费画力星</p>
              <p className={styles.tip}>✏️ ️试试输入</p>
              {promptNode}
              <p className={styles.tip}>👇 你将得到</p>
              <Swiper
                className={classNames("swiper-no-swiping", styles.carouselWrapper, {
                  [styles.noBefore]: promptActive === 0,
                  [styles.noAfter]: promptActive === carouselData.length - 1,
                })}
                initialSlide={promptActive}
                modules={[Mousewheel, FreeMode]}
                mousewheel={{
                  forceToAxis: true,
                }}
                loop
                centeredSlides={true}
                freeMode
                slidesPerView={"auto"}
                onSwiper={(e) => {
                  setSwiper(e);
                }}
                onSlideChange={(e) => {
                  setPromptActive(e.realIndex);
                }}
              >
                {carouselNode}
                <img
                  src="https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/left.png"
                  alt=""
                  className={styles.controller}
                  onClick={() => {
                    swiper.slidePrev();
                  }}
                />
                <img
                  src="https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/right.png"
                  alt=""
                  className={styles.controller}
                  onClick={() => {
                    swiper.slideNext();
                  }}
                />
              </Swiper>
              <p className={styles.bottomTips}>
                温馨提示：画板上的图片可以自由拖动，删除键可删除图片，界面的右下角有帮助中心
              </p>
              <div className={styles.buttonWrapper}>
                <button
                  className={styles.solid}
                  onClick={() => {
                    window.open(
                      "https://f8y4v1rln8.feishu.cn/wiki/wikcnlHLIsZUOnYsCQc3YQUMA4e",
                      "blank",
                    );
                  }}
                >
                  查看使用方法
                </button>
                <button onClick={closeOnboarding}>开始创作</button>
              </div>
            </div>
            {scatteringFlowersVisible && (
              <img
                src="https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/scatteringFlowers.gif"
                alt=""
                className={styles.scatteringFlowers}
              />
            )}
          </div>
        </ModalContent>
      </ModalBody>
    </Modal>
  );
};
export default observer(Onboarding);
